/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Manual_Balancing_Display_FloorInputs */



/**
* | output |
* | --- |
* | "Floor" |
*
* @param {Manual_Balancing_Display_FloorInputs} inputs
* @param {{ locale?: "fr" | "en" }} options
* @returns {LocalizedString}
*/
export const manual_balancing_display_floor = /** @type {((inputs?: Manual_Balancing_Display_FloorInputs, options?: { locale?: "fr" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Manual_Balancing_Display_FloorInputs, { locale?: "fr" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return /** @type {LocalizedString} */ ("Floor")
	return /** @type {LocalizedString} */ ("Niveau")
});